import React from "react";
import { Button } from "antd";
import PropTypes from "prop-types";
import _noop from "lodash/noop";

const SapaButton = ({
  label,
  style,
  shape = "default",
  customClass,
  onClick,
  icon,
  displayIcon = false,
  buttonType = "primary",
  htmlType = "button",
  loading = false,
  disabled = false,
}) => {
  let buttonStyle = "";
  switch (buttonType) {
    case "primary":
      buttonStyle = "button__primary";
      break;
    case "transparent":
      buttonStyle = "button__transparent";
      break;
    default:
      break;
  }
//   const styles = {
//     display: displayIcon 
// }
  return (
    <Button
      className={`button ${buttonStyle} ${customClass}`}
      type="primary"
      shape={shape}
      size={20}
      onClick={onClick || _noop}
      style={style}
      htmlType={htmlType}
      loading={loading}
      disabled={disabled}
    >
      <span>
         {!loading && displayIcon && (<img src={icon} alt="/" />) }
        {label}
      </span>
    </Button>
  );
};

SapaButton.propTypes = {
  label: PropTypes.string,
  shape: PropTypes.oneOf(["circle", "default", "round"]),
  customClass: PropTypes.string,
  onClick: PropTypes.func,
  buttonType: PropTypes.string,
  htmlType: PropTypes.oneOf(["button", "submit", "reset"]),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SapaButton;
